import { Button } from "react-bootstrap";
import { VscTrash } from "react-icons/vsc";
import { useNavigate } from "react-router-dom";
import IconText from "./IconText";

const DeleteButton = ({ url = null, onClick = null }) => {
  const navigate = useNavigate();
  return (
    <Button
      variant="danger"
      size="sm"
      onClick={() => (onClick ? onClick() : navigate(url))}
    >
      <IconText icon={<VscTrash />} />
    </Button>
  );
};

export default DeleteButton;
